var vis = 1000;

//ALERT
window.alert = function (message) {
  //Creazione dell'elemento
  var b = document.createElement("div");
  b.style.cssText =
    " position: fixed; top: 0px; width: 100%; height: 100%; z-index: 999;";
  b.id = "Contenitore-blocca-eventi";
  var a = document.createElement("div");
  //regole di stile CSS
  a.style.cssText =
    ' border:1px solid #bbb; border-radius:5px; padding:10px; background:white; box-shadow:0px 0px 8px #0006; position:fixed; top:20px; right:0; left:0; margin:auto; font-family: "Arial", sans-serif; color:black; z-index:' +
    vis +
    ";";
  a.classList.add("contenitorePersonaleBannerContain");
  a.classList.add("contenitorePersonaleBannerContainHeigth");
  a.innerHTML = message;
  localStorage.setItem("test", 1);

  b.appendChild(a);
  document.body.appendChild(b);
 

  vis--;

  //Rimozione dell'elemento al click
  a.addEventListener("click", function (item) { 
    if (item.srcElement && item.srcElement.id == "bottoneSi") {
      localStorage.setItem("sei-un-operatore-sanitario", "si"); 
      a.remove();
      try {
        document.body.removeChild(
          document.getElementById("Contenitore-blocca-eventi")
        );
      } catch (e) {
        console.log(e);
      }
      try {
        var fintoAlert = document.getElementById('fintoAlert');

        // Mostra il finto alert
        fintoAlert.style.display = 'block';

        
        document.body.classList.add('body-overlay');
        localStorage.setItem('messaggioCosmofarma', 'si');
      } catch (e) {
        console.log(e);
      }
        
    } else if (item.srcElement && item.srcElement.id == "bottoneNo") {
      localStorage.setItem("sei-un-operatore-sanitario", "no");
      window.close();
    }
  });
};

const seiUnOperatoreSanitario = localStorage.getItem("sei-un-operatore-sanitario");  
if (!seiUnOperatoreSanitario || seiUnOperatoreSanitario != "si") {
  alert(` 
<div style="
  display: grid; 
  text-align: center;   
  padding-top:2px; 
  padding-left: 25px; 
  padding-right: 25px;" class="contenitorePersonaleBanner";   
>
  <div style="display: grid;" class="contenitorePersonaleBanner1">
    <h4 style="font-size: small;">
      Accesso al website Medicaltech S.r.l.
    </h4>
    <p style="margin: 0px">
      Avvertenza
    </p>  
    <p style="font-size: small;">
      Le informazioni contenute in questo sito sono destinate in via esclusiva agli operatori professionali della sanità in conformità all’art. 21 del D.Lgs. 24 febbraio 1997, n. 46 s.m.i e alle Linee Guida del Ministero della Salute del 17 febbraio 2010 e successivo aggiornamento del 18 marzo 2013.
    </p> 
    <p style="margin: 0px; font-size: small;">
      Per proseguire cliccare <b>’SI’</b> per uscire cliccare <b>’NO’</b> <br> Il sistema ricorderà la vostra scelta.
    </p>  
  </div>
  <div style="display: grid; padding:10px;" class="contenitorePersonaleBanner2">
    <button id="bottoneSi" class="button button--secondary" style="height: 45px; min-height: 45px;" >si</button> 
  </div>
  <div style="display: grid;padding:10px;" class="contenitorePersonaleBanner3">
    <button id="bottoneNo" class="button button--secondary" style="height: 45px; min-height: 45px;" >no</button>
  </div>
</div> 
`);
} 
else {
  try {
    document.body.removeChild(
      document.getElementById("Contenitore-blocca-eventi")
    );
  } catch (e) {
    console.log(e);
  }
}
